import { extend, setInteractionMode, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

import it from 'vee-validate/dist/locale/it.json'

setInteractionMode('eager')

localize('it', it)

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('required', {
  ...rules.required,
  message: 'Il campo {_field_} è obbligatorio',
})

extend('required_if_empty', {
  params: ['target'],
  computesRequired: true,
  validate(value, { target }) {
    return {
      required: !target,
      valid: value || target,
    }
  },
  message: 'Il campo {_field_} è obbligatorio se {target} non è settato',
})

extend('date', {
  validate(value) {
    return (
      value.match(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/) &&
      !isNaN(new Date(value).valueOf())
    )
  },
  message: 'Il campo {_field_} non è una data valida',
})

extend('link', {
  validate(value) {
    return value.match(
      /^(?:http(s)?:\/\/){1}[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
    )
  },

  message: 'Il campo {_field_} non è un url valido',
})

extend('length_min', {
  validate(value, { min }) {
    return Array.from(value).length >= min
  },
  params: ['min'],

  message: 'Il campo {_field_} deve essere almeno di {min}',
})

extend('confirm', {
  params: ['target'],
  computesRequired: true,
  validate(value, { target }) {
    return {
      required: !!target,
      valid: value === target,
    }
  },
  message: 'Le password non combaciano',
})

/* extend('required_if_not', {
  ...required_if,
  // params: ['target']
  validate: (value, args) => {
      let target_value = args.target;
      return Boolean(target_value || value);
  },
  message: 'Bitte dieses Feld ausfüllen.'
}); */

extend('html_max', {
  params: ['max'],
  validate(value, { max }) {
    return value.replace(/(<([^>]+)>)/gi, '').length < max
  },
  message: '{_field_} non deve superare i {max} caratteri',
})
